<template>
  <transition name="slide-up">
    <div class="modal-overlay" @click.self="$emit('clickOverlay')">
      <div
        class="bottom-modal px-3 pt-1"
        :class="className"
        :style="{ height: modalHeight }"
      >
        <slot name="custom-content"></slot>
        <!-- Default content if no slot is provided -->
        <img
          v-if="modalHeaderImage"
          class="modal-image mt-2 mb-3"
          :src="modalHeaderImage"
          alt="shipments_header"
        />
        <p
          class="text-center title-text mb-3"
          v-if="modalHeaderTitle"
          v-html="modalHeaderTitle"
        ></p>
        <p
          class="text-center subtitle-text mb-5"
          v-if="modalHeaderSubtitle"
          v-html="modalHeaderSubtitle"
        ></p>
        <slot v-if="showActions">
          <Button
            class="w-100"
            @click="modalAction"
            :type="btnType"
            :loading="actionModalLoading"
          >
            <span>{{ btnText }}</span>
          </Button>
          <p
            v-if="btn2Text"
            class="second-button text-center mt-3 mb-0 px-3"
            @click="modalAction2"
          >
            {{ btn2Text }}
          </p>
        </slot>
      </div>
    </div>
  </transition>
</template>
<script setup lang="ts">
import Button from "@/apps/credit-line/components/Button.vue";

defineProps({
  modalHeaderImage: {
    type: String,
    default: "",
  },
  modalHeaderTitle: {
    type: String,
    default: "",
  },
  modalHeaderSubtitle: {
    type: String,
    default: "",
  },
  showActions: {
    type: Boolean,
    default: true,
  },
  btnText: {
    type: String,
  },
  btnType: {
    type: String,
    default: "primary",
  },
  actionModalLoading: {
    type: Boolean,
    default: false,
  },
  btn2Text: {
    type: String,
    default: "",
  },
  className: {
    type: String,
    default: "",
  },
  modalHeight: {
    type: String,
    default: "60%",
  },
});

const emit = defineEmits<{
  (e: "modalAction", value: boolean): void;
  (e: "modalAction2", value?: boolean): void;
  (e: "clickOverlay"): void;
}>();

const modalAction = () => {
  emit("modalAction", false);
};

const modalAction2 = () => {
  emit("modalAction2", false);
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 999;
  pointer-events: auto;
}

.bottom-modal {
  background: white;
  width: 100%;
  border-radius: 16px 16px 0 0;
  padding: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 95%;
  overflow-y: auto;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.modal-image {
  width: 64px;
  height: 64px;
}

.title-text {
  font-family: Inter, serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #111;
  text-align: center;
}

.subtitle-text {
  font-family: Inter, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #595a5a;
  text-align: center;
}

.second-button {
  font-family: Inter, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #007c3b;
  cursor: pointer;
}
</style>
